import React, { PureComponent } from 'react';
import { Layout, Dropdown, Avatar, Menu } from 'antd';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { isFunction } from 'lodash';

import { isMC } from 'src/utils/env';
import { TabHeader } from '../../components/UI/TabHeader';
import { ContextMenu } from '../../components/UI/ContextMenu';
import { $t } from '../../tools';
import { setStorage } from '../../tools/storage';
import styles from './index.less';

const { Header } = Layout;
const userAvatar = 'https://duoke3-image.oss-cn-hangzhou.aliyuncs.com/boss.png';

class GlobalHeader extends PureComponent {
  langs = [
    { key: 'chs', value: '中文' },
    { key: 'en', value: 'English' },
    { key: 'fr', value: 'Français' },
    { key: 'it', value: 'Italiano' },
    { key: 'tr', value: 'Türkçe' },
    { key: 'de', value: 'Deutsche' },
    { key: 'es', value: 'Español'},
    { key: 'pt', value: 'Português'},
    { key: 'ru',value: 'ру́сский язы́к'}
  ];

  get activeKey() {
    return this.props.location.pathname;
  }

  async componentDidMount(){
    const response = await this.props.dispatch({type:"supportLangs/getSupportLangs"})
    if(response){
      const {data} = response
      this.langs = data.map((e) => ({key:e.key,value:e.name}))
      this.setState()
    }
  }

  render() {
    const {
      locales,
      cacheMenus = [],
      persistMenus = [],
      userInfo,
      reportList,
      locale,
    } = this.props;

    const dataSource = [...persistMenus, ...cacheMenus].map(
      (v, index) => (
        (v.key = `/${v.path}`.replace(/\/\//g, '/')),
        (v.data = {
          name: isFunction(v.tab) ? v.tab(reportList?.length) : v.tab || v.name,
          path: v.path,
        }),
        (v['data-context-menu'] = `${index < persistMenus.length ? 'un' : ''}fixed/removed`),
        v
      )
    );

    const menu = (
      <Menu selectedKeys={[]} className={styles.menu} onClick={this.handleUserMenuClick}>
        <Menu.Item key="logout">{$t('logout', locales)}</Menu.Item>
      </Menu>
    );
    return (
      <Header className={styles.header}>
        <ContextMenu
          style={{
            flex: 1,
            marginTop: 4,
          }}
          onMenuClick={this.handleMenuClick}
          way="unknown"
          menus={[
            { title: $t('fixed_navigation', locales), key: 'fixed', icon: 'pushpin' },
            { title: $t('unfixed_navigation', locales), key: 'unfixed', icon: 'disconnect' },
            { title: $t('removed_navigation', locales), key: 'removed', icon: 'delete' },
          ]}
        >
          <TabHeader
            locale={locales}
            dataSource={dataSource}
            activeKey={this.activeKey}
            onChange={this.handleTabMenuChange}
          />
        </ContextMenu>

        <div className={styles.right}>
          {isMC() ? (
            <Dropdown
              overlay={
                <Menu onClick={this.handleToggleLanguage}>
                  {this.langs.map((v) => (
                    <Menu.Item key={v.key}>{v.value}</Menu.Item>
                  ))}
                </Menu>
              }
            >
              <a>{this.langs.find((v) => v.key === locale)?.value}</a>
            </Dropdown>
          ) : (
            <a className={styles['back-old-version']} onClick={this.handleBackOld}>
              回到旧版
            </a>
          )}
          <a icon="loading-3-quarters" className={styles['sync-config']} onClick={this.handleSync}>
            {$t('sync_config1', locales)}
          </a>
          <Dropdown overlay={menu}>
            <span className={`${styles.action} ${styles.account}`}>
              <Avatar
                size="small"
                src={userInfo.img || userInfo.avatar || userAvatar}
                className={styles.avatar}
              />
              <span className={styles.username}>{userInfo.staff_name}</span>
            </span>
          </Dropdown>
        </div>
      </Header>
    );
  }

  handleToggleLanguage = ({ key }) => {
    const { dispatch } = this.props;
    setStorage('mc-locale', key);
    dispatch({ type: 'app/setState', payload: { locale: key } });
  };
  handleBackOld = () => {
    const { token } = this.props;
    window.location.href = `https://w.duoke.net/api/login-pull?token=${token}&from_new=1`;
  };

  handleSync = () => {
    const { dispatch } = this.props;
    dispatch({ type: 'app/syncAppData' });
  };

  handleUserMenuClick = ({ key }) => {
    const { dispatch } = this.props;
    if (key === 'logout') {
      dispatch({ type: 'login/logout' });
    }
  };

  /**
   *
   * @param {HTMLElement} target
   * @memberof GlobalHeader
   */
  handleMenuClick = (menu, data, target) => {
    const { attributes } = target;

    const route = { path: attributes['data-path'].value, name: attributes['data-name'].value };
    switch (menu.key) {
      case 'removed':
        this.handleRemoveMenu(route);
        break;
      case 'fixed':
        this.handleAffixMenu(route);
        break;
      case 'unfixed':
        this.handleUnAffixMenu(route);
        break;
      default:
        break;
    }
  };

  /**
   * 固定菜单
   * @memberof GlobalHeader
   */
  handleAffixMenu = (route) => {
    if (this.props.onAffixMenu) this.props.onAffixMenu(route);
  };

  /**
   * 接触固定
   * @memberof GlobalHeader
   */
  handleUnAffixMenu = (route) => {
    if (this.props.onUnAffixMenu) this.props.onUnAffixMenu(route);
  };

  /**
   * 移除菜单
   * @memberof GlobalHeader
   */
  handleRemoveMenu = (route) => {
    if (this.props.onRemovedMenu) this.props.onRemovedMenu(route);
  };

  handleTabMenuChange = (activeKey) => {
    const { location, history } = this.props;
    if (location.pathname !== activeKey) {
      history.push(activeKey);
    }
  };
}

export default withRouter(
  connect(({ appState }) => ({
    token: appState.token,
    locale: appState.locale,
    userInfo: appState.userInfo,
    reportList: appState.reportList,
  }))(GlobalHeader)
);
